import { render, staticRenderFns } from "./RelatorioCobrancasGeral.vue?vue&type=template&id=75a61303&scoped=true"
import script from "./RelatorioCobrancasGeral.vue?vue&type=script&lang=js"
export * from "./RelatorioCobrancasGeral.vue?vue&type=script&lang=js"
import style0 from "./RelatorioCobrancasGeral.vue?vue&type=style&index=0&id=75a61303&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a61303",
  null
  
)

export default component.exports